/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IGetAvailableMultiOffersRequestV2 {
  /** Идентификатор региона **/
  regionId: number;
  /** Стоимость объекта **/
  objectCost: number;
  /** Первоначальный взнос **/
  downPayment: number;
  /** Срок кредита (в годах) **/
  loanTermYears: number;
  /** Льготная ипотечная программа **/
  benefitProgram: EBenefitProgram;
  /** Тип объекта **/
  objectType: EObjectType;
  /** Тип недвижимости **/
  realEstateType: ERealEstateType;
  /** Тип занятости **/
  employmentType: EEmploymentType;
  /** Подтверждение дохода **/
  incomeConfirmation: EIncomeConfirmation;
  /** ID банка зарплатного проекта **/
  payrollBankId?: TGetAvailableMultiOffersRequestV2_PayrollBankId;
  /** ID банка для расчета предложений **/
  bankId?: TGetAvailableMultiOffersRequestV2_BankId;
}

export enum EBenefitProgram {
  /** Базовая **/
  'NoProgram' = 'noProgram',
  /** Господдержка 2020 **/
  'GovernmentSupport2020' = 'governmentSupport2020',
  /** Семейная **/
  'Family' = 'family',
  /** ИТ-ипотека **/
  'It' = 'it',
  /** ИЖС ХОЗСПОСОБОМ **/
  'IzhsHozsposopom' = 'izhsHozsposopom',
}
export enum EObjectType {
  /** Квартира **/
  'Flat' = 'flat',
  /** Апартаменты **/
  'Apartments' = 'apartments',
  /** Дом **/
  'House' = 'house',
  /** Машиноместо **/
  'CarPlace' = 'carPlace',
}
export enum ERealEstateType {
  /** Новостройка **/
  'NewBuilding' = 'newBuilding',
  /** Вторичка **/
  'Secondary' = 'secondary',
  /** Строительство дома **/
  'HouseBuilding' = 'houseBuilding',
}
export enum EEmploymentType {
  /** Полная занятость **/
  'Employee' = 'employee',
  /** Самозанятый **/
  'SelfEmployed' = 'selfEmployed',
  /** ИП **/
  'Entrepreneur' = 'entrepreneur',
  /** Владелец бизнеса **/
  'BusinessOwner' = 'businessOwner',
}
export enum EIncomeConfirmation {
  /** С подтверждением **/
  'Confirmation' = 'confirmation',
  /** Без подтверждения **/
  'NoConfirmation' = 'noConfirmation',
}
export type TGetAvailableMultiOffersRequestV2_PayrollBankId = null | number;

export type TGetAvailableMultiOffersRequestV2_BankId = null | number;
